@if (isImage$ | async) {
  <img [src]="contextValue$ | async" />
} @else if (isUrl$ | async) {
  <a
    [href]="contextValue$ | async"
    target="_blank"
    (click)="$event.stopPropagation()"
    >{{ contextValue$ | async }}</a
  >
} @else {
  <div>{{ contextValue$ | async }}</div>
}
